import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import '../styles/accessibility.css';

// SF: Added 9.13.24 to support fass and fasr variants (ALEX)
import '@fortawesome/fontawesome-pro/css/sharp-solid.css'
import '@fortawesome/fontawesome-pro/css/sharp-regular.css'

Vue.use(Vuetify);

const DEFAULT_VUETIFY_SECONDARY_COLOR = '#424242';
const DEFAULT_PRIMARY_COLOR = '#1A237E';

const DEFAULT_OPTIONS = {
	primaryColor: DEFAULT_PRIMARY_COLOR,
	secondaryColor: DEFAULT_VUETIFY_SECONDARY_COLOR,
	icons: {}
};

function createVuetifyInstance(options = DEFAULT_OPTIONS) {
	return new Vuetify({
		icons: {
			iconfont: 'fa',
			values: options.icons || {},
		},
		theme: {
			light: true,
			options: { customProperties: true }, 
			themes: {
				light: {
					// Default primary color
					primary: options.primaryColor || DEFAULT_PRIMARY_COLOR,
					secondary: options.secondaryColor || DEFAULT_VUETIFY_SECONDARY_COLOR,
				}
			}
		}
	});
}

export default createVuetifyInstance;
